import ChatMessage from './ChatMessage';

export default ChatMessage;



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/index.js